import FormDataHandler from '../functions/FormDataHandler'

export const testFormSubmit = (formData, setFormError, setFormStatus) => {
  const dataHandler = new FormDataHandler()
  const testFormData = {
    '0': {
      firstName: 'Adrian',
      middleName: '',
      lastName: 'Halliday',
      homePhone: '',
      mobile: '0421080372',
      email: 'adrian@mustardcreative.com.au',
      confirmEmail: 'adrian@mustardcreative.com.au',
      dob: '28/02/1983',
    },
    '1': {
      postalAddressOne: 'sdfdsf',
      postalAddressTwo: '',
      postalAddressCity: 'dsfsdf',
      postalAddressPostCode: '1234',
      postalAddressState: {
        label: 'ACT',
        value: 'ACT',
      },
      postalAddressCountry: {
        value: 'AU',
        label: 'Australia',
      },
      billingaddressone: 'sdfdsf',
      billingaddresstwo: '',
      billingcity: 'dsfsdf',
      billingpostcode: '1234',
      billingstate: {
        label: 'ACT',
        value: 'ACT',
      },
      billingcountries: {
        value: 'AU',
        label: 'Australia',
      },
    },
    '2': {
      licenseNumber: '123456',
      licenseState: {
        label: 'VIC',
        value: 'VIC',
      },
      licenseExpiration: '05/05/2025',
      acceptTerms: true,
    },
  }

  dataHandler.sendFormData(testFormData, function(response) {
    if (response.success) {
      setNewMemberNumber(response.data.newUserId)
      setFormStatus('complete')

      dataHandler.sendEmailSubscription(
        formData[0].email,
        response.data.newUserId,
        formData[0].firstName,
        isPromoForm,
      )

      const formHeaderContainer = document.getElementById('blue-chip-form-header')
      formHeaderContainer.scrollIntoView()
    } else {
      setFormError(response.data.content)
      setFormStatus('in-progress')

      const formContainer = document.getElementById('blue-chip-form-container')
      formContainer.scrollIntoView()
    }
  })
}
